import { render } from "preact";
import "@fontsource/big-shoulders-display/700";
import "@fontsource/big-shoulders-display/900";
import "@fontsource/atkinson-hyperlegible/400";
import "@fontsource/atkinson-hyperlegible/700";
import "@fontsource/jetbrains-mono/400";
import "@fontsource/barlow-condensed/700-italic";
import "@fontsource/barlow-condensed/800-italic";
import "@fontsource/barlow-condensed/900-italic";
// Map lettering: inscriptions and comic balloons (maps/brussels/panels.ts), and the script of
// postcards and neon (maps/orlando/panels.ts).
import "@fontsource/cinzel/700";
import "@fontsource/comic-neue/700";
import "@fontsource/pacifico/400";
import "./styles.css";
import { installUiSounds } from "./audio/ui.ts";
import { App } from "./ui/App.tsx";

installUiSounds();

render(<App />, document.getElementById("app")!);
